import { MouseEvent, ReactElement } from 'react'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import { Box, ButtonBase, Tooltip } from '@mui/material'
import type { FindingSeverity } from 'src/state/stores/aiChatFindings'
import { SEVERITY_COLORS } from './utils'

interface Props {
  severity: FindingSeverity
  count: number
  isOpen: boolean
  tooltip: string
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

/**
 * The "!" of an element's findings, in the colour of the worst one (errors red, warnings amber,
 * hints blue), with their number when there are several.
 */
const FindingBadge = ({ severity, count, isOpen, tooltip, onClick }: Props): ReactElement => (
  <Tooltip title={tooltip} disableInteractive>
    <ButtonBase
      onClick={onClick}
      aria-label={tooltip}
      sx={{
        position: 'relative',
        width: 24,
        height: 24,
        flexShrink: 0,
        borderRadius: '50%',
        bgcolor: SEVERITY_COLORS[severity],
        color: 'common.white',
        boxShadow: isOpen ? 4 : 1,
        outline: isOpen ? 2 : 0,
        outlineColor: 'common.white',
      }}
      data-cy="scene-finding-marker"
    >
      <PriorityHighIcon sx={{ fontSize: 16 }} />
      {count > 1 && (
        <Box
          component="span"
          sx={{
            position: 'absolute',
            top: -6,
            right: -8,
            minWidth: 16,
            height: 16,
            px: 0.25,
            borderRadius: 8,
            bgcolor: 'common.white',
            color: 'text.primary',
            border: 1,
            borderColor: SEVERITY_COLORS[severity],
            fontSize: 10,
            lineHeight: '14px',
            fontWeight: 600,
          }}
          data-cy="scene-finding-marker-count"
        >
          {count}
        </Box>
      )}
    </ButtonBase>
  </Tooltip>
)

export default FindingBadge
